import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Szczegóły umowy',
  tabs: {
    [info_tab]: 'Informacje',
    [contract_tab]: 'Umowa',
    [versioning_tab]: 'Wersjonowanie',
  },
  sections: {
    price_info: 'Informacje o cenie',
    contact: 'Aktualny kontrakt',
    signature_history: 'Historia podpisów',
  },
  labels: {
    not_signed: 'Kontrakt nie został jeszcze podpisany',
  },
  modals: {
    preview_contract: {
      title: 'Podgląd kontraktu',
    },
    switch_to_annual: {
      title: 'Przejdź na roczny',
    },
  },
  buttons: {
    save: 'Zapisz',
    preview_and_sign: 'Podgląd i podpisanie',
    download: 'Pobierz',
    switch_to_annual: 'Przejdź na roczny',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się wczytać danych',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
